<template>
  <div class="booksManagement">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>专家档案</h4>
      </div>
      <div class="head-right">
        <div class="head-right-input">
          <el-input
            :clearable="true"
            placeholder="请输入专家名称"
            v-model="managementInput"
            clearable
            @change="change"
          >
          </el-input>
          <el-button
            size="medium"
            style="background: #484c7f; color: #fff"
            @click="searchmanagemen"
          >搜索</el-button>
        </div>
        <div class="head-right-btn">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="documentationCreate"
          >新建档案</el-button>
        </div>
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- 表单 -->
    <div class="table">
      <div class="table-head">
        <h3 class="table-head-1">专家姓名</h3>
        <h3 class="table-head-2">所属项目</h3>
        <h3 class="table-head-3">文献数量</h3>
        <h3 class="table-head-4">浏览量</h3>
        <h3 class="table-head-5">操作</h3>
      </div>
      <!-- 内容 -->
      <ul class="table-Contents">
        <li
          v-for="(item,index) in questionnairesObject.list"
          :key="index"
        >
          <div class="table-Contents-item">
            <div class="table-Contents-item-n">
              <div class="table-Contents-item-n-img">
                <img src="../../assets/image/books/xingming.png">
              </div>
              <div>{{item.expert_name}}</div>
            </div>
            <div class="table-Contents-item-x">{{item.ent_name}}</div>
            <div class="table-Contents-item-s">{{item.literature_num}}</div>
            <div class="table-Contents-item-l">{{item.views}}</div>
            <ul class="table-Contents-item-c">
              <li
                class="table-Contents-item-c-b"
                @click="uploadProtocol(item)"
              >
                <div class="table-Contents-item-c-b-1">
                  <img src="../../assets/image/books/shangchuan.png">
                </div>
                <div>上传协议</div>
              </li>
              <li
                class="table-Contents-item-c-b"
                @click="viewlIteratureClick(item)"
              >
                <div class="table-Contents-item-c-b-2">
                  <img src="../../assets/image/books/chakan.png">
                </div>
                <div>查看文献</div>
              </li>
              <li
                class="table-Contents-item-c-b"
                @click="editdocumentClick(item)"
              >
                <div class="table-Contents-item-c-b-3">
                  <img src="../../assets/image/books/bianji.png">
                </div>
                <div>编辑档案</div>
              </li>
              <li
                class="table-Contents-item-c-b"
                @click="deleteList(item)"
              >
                <div class="table-Contents-item-c-b-4">
                  <img src="../../assets/image/books/shanchu.png">
                </div>
                <div>删除</div>
              </li>
            </ul>
            <div
              v-if="item.agreement_url!=''"
              class="expand-btn"
              @click="expandBtn(index,item)"
            >
              <div v-if="item.showDetail">
                <i class="el-icon-arrow-up"></i>
              </div>
              <div v-else>
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
          <!-- 展开收起   v-if="hudiashdoa==index && hdusiahdoasijdipsa" -->
          <transition name="list">
            <div
              class="show-expand"
              v-if="item.showDetail"
            >
              <ul class="show-expand-ul">
                <li
                  class="show-expand-item"
                  v-for="(item1,index) in  item.agreement_url"
                  :key="index"
                >
                  <div class="show-expand-item-name">{{item1.agreement_name}}
                  </div>
                  <div class="show-expand-item-time">{{item1.created_at}}</div>
                  <div class="show-expand-item-heng"></div>
                  <div class="show-expand-item-xieyi">
                    <div class="show-expand-item-xieyi-img">
                      <img src="../../assets/image/books/quan.png">
                    </div>
                    <div class="show-expand-item-right-img">
                      <img src="../../assets/image/books/youce.png">
                    </div>
                    <div
                      class="show-expand-item-xieyi-text"
                      @click="viewAgreement(item1)"
                    >查看协议</div>
                  </div>
                </li>
              </ul>
            </div>
          </transition>
          <!-- 展开收起 -->
        </li>
      </ul>
      <!-- 内容 -->
    </div>
    <div
      class="not-available"
      v-if="questionnairesObject.list.length==0"
    >暂无数据</div>
    <!-- 表单 -->
    <!-- 上传协议 -->
    <div class="upload-protocol">
      <el-dialog
        title="上传协议"
        :visible.sync="protocolShow"
        width="30%"
      >
        <!-- 内容 -->
        <div class="upload-protocol-contents">
          <!-- <div>
            <div class="upload-protocol-contents-top">
              <div class="must">*</div>
              <div>协议名称</div>
            </div>
            <el-input
              style=" width: 80%;"
              v-model="uploadinput"
              placeholder="请输入项目名称"
            ></el-input>
          </div> -->

          <div style="display: flex;align-items: center; margin: 5px 0 12px 0;">
            <div class="must">*</div>
            <div>上传文件</div>
          </div>

          <div class="uploads-box">
            <el-upload
              class="upload-demo"
              :action="action"
              multiple
              :file-list="fileList"
              :on-success="accessorySuccess"
              :data="{file:'file',model:'agreement',expert_name: expetName}"
              ref="accessory"
              v-model="enclosure"
              :limit="1"
              :before-remove="beforeremove"
            >
              <el-button
                size="small"
                type="info"
              >选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">允许上传PDF和照片类型文件</span>
          </div>

          <div
            style="margin: 50px 0 12px 0;"
            v-if="agreementName"
          >{{agreementName}}</div>

        </div>
        <!-- 内容 -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="protocolShow = false">取 消</el-button>
          <el-button
            type="primary"
            @click="uploadProtocolCreate"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 上传协议 -->
    <div
      class="page"
      v-show="questionnairesObject.list!=0"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="questionnairesObject.pages"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>
  </div>
</template> 

<script> 
export default {
  name: 'booksArchives',
  data () {
    return {
      pagesize: 8,//每页显示条目个数 
      currentPage: 1,//当前页数  
      protocolShow: false,//上传协议弹窗
      uploadinput: '',//上传协议名称
      uploadID: '',//上传协议id
      action: `https://laravel.gongshicloud.com/api/index/upload`,//上传地址
      fileList: [],
      enclosure: '', //附件
      managementInput: '',
      questionnairesObject: { list: [] },
      hudiashdoa: 0,
      hdusiahdoasijdipsa: false,
      expetName: '',
      agreementName: '',
    }
  },
  activated () {
    this.getSpecialistProfiles()//获取列表
  },
  methods: {
    //抬头回车 
    change (value) {
      this.managementInput = value
      this.currentPage = 1
      setTimeout(() => {
        this.getSpecialistProfiles()
      }, 500)
      this.$Spin.show();
    },
    //搜索按钮
    searchmanagemen () {
      this.currentPage = 1
      setTimeout(() => {
        this.getSpecialistProfiles()
      }, 500)
      this.$Spin.show();
    },
    //新建档案
    documentationCreate () {
      this.$router.push({
        path: 'newSpecialistProfiles',
        query: {
          ent_id: this.$route.query.id
        }
      })
    },
    //展开收起 
    expandBtn (index, item) {
      item.showDetail = this.$set(item, "showDetail", !item.showDetail);
    },
    //查看协议 
    viewAgreement (item) {
      window.open(item.url)
    },
    //获取专家档案
    async getSpecialistProfiles () {
      const { data: data } = await this.$http.post('library/expertDetail', {
        project_id: this.$route.query.id,
        name: this.managementInput,
        limit: this.pagesize,//每页条数    
        page: this.currentPage,//第几页  
      })
      this.questionnairesObject = data.data
      this.$Spin.hide();
    },
    //上传协议 打开
    uploadProtocol (item) {
      this.uploadID = item.id
      this.enclosure = ''
      this.uploadinput = ''
      this.fileList = []
      this.protocolShow = true
      this.expetName = item.expert_name
    },
    //上传协议接口
    accessorySuccess (res, file, fileList,) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.accessory.clearFiles()
        return
      }
      this.$Loading.finish()
      this.enclosure = res.data.url
      this.agreementName = res.data.agreementName
    },
    //删除附件
    beforeremove (res, file, fileList) {
      this.enclosure = ''
      this.fileList = []
    },
    //上传协议 确定
    async uploadProtocolCreate () {
      const { data: data } = await this.$http.post('archives/upload-agreement', {
        id: this.uploadID,
        url: this.enclosure,
        agreement_name: this.agreementName,
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.protocolShow = false
      this.getSpecialistProfiles()
    },
    //查看文献 
    viewlIteratureClick (item) {
      this.$router.push({
        path: 'booksLiteratureList',
        query: {
          id: item.id,
          library_ent_id: item.library_ent_id,
          library_expert_id: item.library_expert_id,
          ent_name: item.ent_name,
          expert_name: item.expert_name,
        }
      })
    },
    //编辑档案
    editdocumentClick (item) {
      this.$router.push({
        path: 'newSpecialistProfiles',
        query: {
          ent_id: this.$route.query.id, //最外侧ia
          library_ent_id: item.library_ent_id,//项目id
          library_expert_id: item.library_expert_id//档案id  
        }
      })
    },
    //删除档案
    deleteList (item) {
      this.$confirm('该专家删除后，档案下的相关文献等信息也会删除，确定要删除该专家吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('archives/delete', { id: item.id })
        this.getSpecialistProfiles()
        this.$message({
          message: data.message,
          type: 'success'
        });
      }).catch(() => { })
    },
    //点击每一页  
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getSpecialistProfiles()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getSpecialistProfiles()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getSpecialistProfiles()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script>
<style lang="less" scoped>
.booksManagement {
  background-color: #f9fbfd;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }
    .head-right {
      display: flex;
      .head-right-input {
        display: flex;
        align-items: center;
        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
      .head-right-btn {
        margin-left: 190px;
      }
    }
  }
  //表格
  .table {
    //头部
    .table-head {
      width: 100%;
      height: 80px;
      background-color: #f1f6ff;
      padding: 0 15px;
      display: flex;
      align-items: center;
      h3 {
        font-size: 16px;
        color: #212529;
      }
      .table-head-1 {
        width: 20%;
      }
      .table-head-2 {
        width: 25%;
      }
      .table-head-3 {
        width: 13%;
      }
      .table-head-4 {
        width: 13%;
      }
      .table-head-5 {
        flex: 1;
      }
    }
    //内容
    .table-Contents {
      width: 100%;
      min-height: 545px;
      position: relative;
      transition: 0.4s all;
      .table-Contents-item {
        position: relative;
        width: 100%;
        padding: 42px 35px 70px 18px;
        margin-top: 18px;
        background-color: #fff;
        // background-color: pink;
        font-size: 13px;
        color: #212529;
        display: flex;
        //下拉按钮
        .expand-btn {
          position: absolute;
          bottom: 0;
          left: 48%;
          width: 85px;
          height: 25px;
          border-radius: 8px 8px 0px 0px;
          background-color: pink;
          background-color: #f4f6fb;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .table-Contents-item-n {
          width: 20%;
          display: flex;
          align-items: center;
          .table-Contents-item-n-img {
            width: 16px;
            height: 17px;
            margin-right: 5px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .table-Contents-item-x {
          padding-right: 15px;
          width: 25%;
        }
        .table-Contents-item-s {
          width: 13%;
        }
        .table-Contents-item-l {
          width: 13%;
        }
        .table-Contents-item-c {
          flex: 1;
          display: flex;
          justify-content: space-between;
          color: #6e80a4;
          .table-Contents-item-c-b {
            display: flex;
            align-items: center;
            cursor: pointer;
            .table-Contents-item-c-b-1 {
              width: 22px;
              height: 15px;
              margin-right: 5px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .table-Contents-item-c-b-2 {
              width: 15px;
              height: 16px;
              margin-right: 5px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .table-Contents-item-c-b-3 {
              width: 16px;
              height: 16px;
              margin-right: 5px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .table-Contents-item-c-b-4 {
              width: 14px;
              height: 16px;
              margin-right: 5px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      //展开收起
      .show-expand {
        padding: 50px 60px 0 60px;
        background-color: #f4f6fb;
        width: 100%;
        .show-expand-ul {
          display: flex;
          flex-wrap: wrap;
          .show-expand-item {
            position: relative;
            // width: 305px;  //!原来的值
            width: 21%;
            padding: 25px 20px;
            border-radius: 6px;
            margin-right: 74px;
            margin-bottom: 50px;
            background-color: #ffffff;
            cursor: pointer;
            overflow: hidden;

            .show-expand-item-right-img {
              width: 52px;
              height: 78px;
              position: absolute;
              top: 20px;
              right: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .show-expand-item-name {
              font-size: 14px;
              // padding-right: 40px;
              margin-right: 23px;
              color: #212529;
              font-weight: 600;
              margin-bottom: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .show-expand-item-time {
              font-size: 14px;
              color: #c2c2c2;
              margin-bottom: 10px;
            }
            .show-expand-item-heng {
              width: 100%;
              height: 0.5px;
              background-color: #e8e8e8;
            }
            .show-expand-item-xieyi {
              display: flex;
              align-content: center;
              justify-content: center;
              margin-top: 20px;
              .show-expand-item-xieyi-img {
                width: 17px;
                height: 17px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .show-expand-item-xieyi-text {
                margin-left: 8px;
                font-size: 14px;
                font-weight: 600;
                color: #2d6aea;
                margin-top: -2px;
              }
            }
          }
          .show-expand-item:nth-child(4n) {
            margin-right: 0 !important;
          }
        }
      }
    }
  }

  .page {
    margin-top: 30px;
    text-align: right;
  }

  //暂无数据
  .not-available {
    position: absolute;
    top: 63%;
    left: 55%;
  }

  .must {
    font-size: 18px;
    color: #ff0d0d;
    margin-right: 6px;
  }
  .upload-protocol {
    //名称
    .upload-protocol-contents {
      .upload-protocol-contents-top {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
      }
    }
    //附件
    //新的
    .uploads-box {
      position: relative;
      .upload-demo {
        align-items: center;
        .el-button {
          border-radius: 6px 0 0 6px;
        }
        .box {
          position: absolute;
          top: 1px;
          left: 80px;
          // width: 421px;
          width: 65%;
          height: 32px;
          border: 1px solid #f0f0f0;
          border-radius: 0 6px 6px 0;
        }

        //文件位置
        /deep/ .el-upload-list__item {
          position: absolute !important;
          top: -6px !important;
          left: 80px !important;
          width: 64% !important;
        }
      }
      .ticks {
        position: absolute;
        color: #cc0808;
        font-size: 12px;
        margin-left: 3px;
        margin-top: 10px;
      }
    }
  }

  //显示
  // .list-enter-active {
  //   animation: fade-in-left 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  // }
  // @keyframes fade-in-left {
  //   0% {
  //     transform: translateX(-50px);
  //     opacity: 0;
  //   }
  //   100% {
  //     transform: translateX(0);
  //     opacity: 1;
  //   }
  // }

  // //离开
  // .list-leave-to {
  //   animation: fade-out-right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  // }
  // @keyframes fade-out-right {
  //   0% {
  //     transform: translateX(0);
  //     opacity: 1;
  //   }
  //   100% {
  //     transform: translateX(50px);
  //     opacity: 0;
  //   }
  // }
}
</style> 